import React from 'react'

function NewsSection() {
  return (
    <div>
            {/* <!-- GT News Section Start --> */}
        <section class="gt-news-section section-padding">
            <div class="container">
                <div class="section-title-area">
                    <div class="section-title">
                    <h5 class="wow fadeInUp"><i class="flaticon-home"></i>REAL ESTATE INSIGHTS</h5>
                    <h2 class="wow fadeInUp" data-wow-delay=".3s">Property News & Updates</h2>
                </div>
                    <a href="/blogdetail" class="theme-btn wow fadeInUp" data-wow-delay=".4s">View All Blog <i class="flaticon-home"></i></a>
                </div>
                <div class="row">
                    <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".3s">
                        <div class="gt-news-box-items">
                            <div class="gt-thumb">
                                <img src="/img/prop.png" alt="img"/>
                                <img src="/img/prop.png" alt="img"/>
                            </div>
                            <div class="gt-content">
                                <ul class="gt-list">
                                    <li>
                                        <i class="fa-solid fa-calendar-days"></i>
                                        September 29, 2025
                                    </li>
                                    <li>
                                       Tips & Tricks
                                    </li>
                                </ul>
                                <h3>
                                    <a href="/blogdetail">Why Investing in a Shree JRB Property is a Smart Choice</a>
                                </h3>
                                <a href="/blogdetail" class="theme-btn">Read More <i class="flaticon-right-arrow"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".5s">
                        <div class="gt-news-box-items">
                            <div class="gt-thumb">
                                <img src="/img/map.jpg" alt="img"/>
                                <img src="/img/map.jpg" alt="img"/>
                            </div>
                            
                            <div class="gt-content">
                                <ul class="gt-list">
                                    <li>
                                        <i class="fa-solid fa-calendar-days"></i>
                                        September 28, 2025
                                    </li>
                                    <li>
                                       Hotel
                                    </li>
                                </ul>
                                <h3>
                                    <a href="/blogdetail">Buying vs. Renting – Which Is Right for You?</a>
                                </h3>
                                 <a href="/blogdetail" class="theme-btn">Read More <i class="flaticon-right-arrow"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".7s">
                        <div class="gt-news-box-items">
                            <div class="gt-thumb">
                                <img src="/img/new2.jpeg" alt="img"/>
                                <img src="/img/new2.jpeg" alt="img"/>
                            </div>
                            <div class="gt-content">
                                <ul class="gt-list">
                                    <li>
                                        <i class="fa-solid fa-calendar-days"></i>
                                        September 27, 2025
                                    </li>
                                    <li>
                                      Tips & Enjoy
                                    </li>
                                </ul>
                                <h3>
                                    <a href="/blogdetail">Why Shree JRB Property is a Smart Choice</a>
                                </h3>
                                 <a href="/blogdetail" class="theme-btn">Read More <i class="flaticon-right-arrow"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
  )
}

export default NewsSection